// Scan Again on the guest page (Robert, 2026-10-13, cutover day).
// The live app's Scan Again opened its scan.html camera and then the label it read.
// The new build had a placeholder notice. This reads the next label with the same
// camera reader the QEW bag tag scan uses (qr-scanner.ts) and says where to go.

import { readQrLink } from "./qr-link";

export type ScanTarget = { kind: "open"; id: string; path: string } | { kind: "refused"; message: string };

const NOT_SAFETAG = "That is not a SafeTag label. Scan the QR on the next label.";

/** SafeTag addresses a printed label or an emailed link can carry. */
const SAFETAG_HOSTS = new Set([
  "getsafetag.com",
  "www.getsafetag.com",
  "test.getsafetag.com",
  "getsafetag-prod.web.app",
  "getsafetag-dev.web.app",
]);

/**
 * What a scanned QR opens. `hereHost` is the host the app runs on, so dev, test and prod
 * each accept their own links. The path is kept on this host: a dev scan stays on dev.
 */
export function scanAgainTarget(link: string, hereHost: string): ScanTarget {
  let url: URL;
  try {
    url = new URL(link.trim());
  } catch {
    return { kind: "refused", message: NOT_SAFETAG };
  }
  if (!SAFETAG_HOSTS.has(url.hostname.toLowerCase()) && url.host !== hereHost) {
    return { kind: "refused", message: NOT_SAFETAG };
  }

  const quiz = url.searchParams.get("quiz");
  if (quiz !== null && url.searchParams.get("aid") === null && url.searchParams.get("tag") === null) {
    const n = quiz.trim();
    if (!/^\d{1,2}$/.test(n)) return { kind: "refused", message: NOT_SAFETAG };
    return { kind: "open", id: `Quiz ${n}`, path: `/?quiz=${n}` };
  }

  const read = readQrLink(link);
  if (read.kind === "asset") return { kind: "open", id: read.assetId, path: `/?aid=${encodeURIComponent(read.assetId)}` };
  if (read.kind === "badge") return { kind: "open", id: read.badgeId, path: `/?tag=${encodeURIComponent(read.badgeId)}` };
  return { kind: "refused", message: NOT_SAFETAG };
}
